module.exports = __webpack_public_path__ + "img/1.15bb2bcd.png";